"use strict";

var RunoffRatioOpportunityLayer = function () {
  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    loadColumnArrayUpdatedListener(mapId);
    loadToggledListenerForMap(map, mapLayers, mapId);
    loadDataUpdatedListenerForMap(map, mapLayers, mapId);
    loadFiltersUpdatedListenerForMap(map, mapLayers, mapId);
  };

  var loadToggledListenerForMap = function (map, mapLayers, mapId) {
    MapFunctions.whenLayerToggled(
      mapId,
      "runoffRatioOpportunity",
      function (isEnabled, sameSpatialFilter, sameView, sameGroup) {
        var telrLayer = mapLayers.runoffRatioOpportunityLayer;
        var sameLayerDropdown =
          Tree.get("layers", mapId, "runoffRatioOpportunity", "layerDropdown") ===
          Tree.get("layerDropdown", mapId);
        var forceRefresh = !sameView || !sameGroup || !sameLayerDropdown;
        if (isEnabled) {
          TelrLayerFunctions.displayTelrLayer(
            telrLayer,
            "runoffRatioOpportunity",
            "percentRate",
            map,
            mapLayers,
            forceRefresh,
          );
        } else {
          if (MapFunctions.mapHasLayer(map, telrLayer)) {
            map.removeLayer(telrLayer);
          }
        }
      },
    );
  };

  var loadDataUpdatedListenerForMap = function (map, mapLayers, mapId) {
    MapFunctions.whenLayerDataUpdated(Tree, mapId, "runoffRatioOpportunity", function (data) {
      mapLayers.runoffRatioOpportunityLayer = addRunoffRatioOpportunityLayer(
        map,
        mapLayers.runoffRatioOpportunityLayer,
        data,
      );
      TelrLayerFunctions.selectTelrCatchmentsByFilter(mapLayers.runoffRatioOpportunityLayer);
      if (
        Tree.get("layers", mapId, "catchments", "isEnabled") &&
        !Tree.get("layers", mapId, "catchments", "isFetching")
      ) {
        Table.render();
      }
    });
  };

  var addRunoffRatioOpportunityLayer = function (map, runoffRatioOpportunityLayer, layerData) {
    if (runoffRatioOpportunityLayer) {
      map.removeLayer(runoffRatioOpportunityLayer);
    }
    runoffRatioOpportunityLayer = new (Layers.getLayers().RunoffRatioLayer)(layerData).addTo(map);
    return runoffRatioOpportunityLayer;
  };

  var loadFiltersUpdatedListenerForMap = function (map, mapLayers, mapId) {};

  var loadColumnArrayUpdatedListener = function (mapId) {
    Tree.select(["layers", mapId, "runoffRatioOpportunity", "columnArray"]).on(
      "update",
      function (e) {
        const DataViewDropdown = require("../mapFunctions/dataViewDropdown");
        var columns = e.data.currentData;
        DataViewDropdown.updateLegendColumns(columns, "runoff-ratio-opportunity");
      },
    );
  };

  var getColumnValues = function () {
    return [0, 10, 25, 40, 50];
  };

  return {
    loadLayerListenersForMap,
    getColumnValues,
  };
};

module.exports = RunoffRatioOpportunityLayer();

const MapFunctions = require("../mapFunctions/mapFunctions");
const Tree = require("../../tree");
const Table = require("../mapFunctions/table");
const Layers = require("../mapFunctions/layers");
const TelrLayerFunctions = require("./telrLayerFunctions");
